import { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Sparkles, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function SampleDataCard() {
  const [seeding, setSeeding] = useState(false);
  const [clearing, setClearing] = useState(false);

  const seed = async () => {
    setSeeding(true);
    try {
      const { data } = await api.post("/admin/sample-data");
      toast.success(data?.message || "Sample data seeded");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSeeding(false); }
  };

  const clear = async () => {
    setClearing(true);
    try {
      const { data } = await api.delete("/admin/sample-data");
      toast.success(`Cleared ${data.removed.shots} shots, ${data.removed.vials} vials, ${data.removed.weights} weights`);
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setClearing(false); }
  };

  return (
    <Card className="bg-white border border-slate-200 rounded-none p-6" data-testid="sample-data-card">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-8 h-8 flex items-center justify-center bg-zinc-800">
          <Sparkles className="w-4 h-4 text-[#0D9488]" />
        </div>
        <div>
          <div className="font-mono-num text-[11px] uppercase tracking-[0.3em] text-slate-500">// Demo</div>
          <div className="font-display font-black uppercase tracking-tight text-xl">Sample Data</div>
        </div>
      </div>
      <p className="text-slate-600 text-sm mb-4 max-w-2xl leading-relaxed">
        Populate the admin account with 30 days of demo shots, a reconstituted vial, and 10 weight entries so the Dashboard, Inventory, History, and Activity heatmap look realistic for screenshots or a live walkthrough. Everything tagged as demo — click <strong className="text-slate-900">Clear</strong> to remove it all in one shot.
      </p>
      <div className="flex gap-2 flex-wrap">
        <Button type="button" onClick={seed} disabled={seeding}
          className="rounded-none uppercase tracking-widest font-semibold h-10 bg-[#0D9488] hover:bg-[#0F766E] text-black"
          data-testid="sample-data-seed">
          <Sparkles className="w-4 h-4 mr-2" /> {seeding ? "Seeding…" : "Populate sample data"}
        </Button>
        <Button type="button" onClick={clear} disabled={clearing} variant="outline"
          className="rounded-none border-slate-200 bg-transparent hover:bg-slate-50 text-slate-800 h-10"
          data-testid="sample-data-clear">
          <Trash2 className="w-4 h-4 mr-2" /> {clearing ? "Clearing…" : "Clear demo rows"}
        </Button>
      </div>
    </Card>
  );
}
